import styled from "styled-components";

export const StarText = styled.span`
	color: #000;
	font-size: 16px;
	font-style: normal;
	font-weight: 500;
	line-height: 140%;
	@media screen and (max-width: 1024px) {
		font-size: 13px;
	}
`;
